import { render, staticRenderFns } from "./AvailabilityForm.vue?vue&type=template&id=5bff2cd4&scoped=true"
import script from "./AvailabilityForm.vue?vue&type=script&lang=js"
export * from "./AvailabilityForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bff2cd4",
  null
  
)

export default component.exports